import { ErrorMessage, Field } from "formik";
import React, { useEffect, useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { IoIosArrowDown } from "react-icons/io";
import data from '../../../CommonUtilities/StaticData/DistMandal.json';
import Swal from "sweetalert2";

export function getTypeOfStudyLabel(typeOfStudy, index) {
    const suffix = (n) => {
        if (n === 1) return '1st';
        if (n === 2) return '2nd';
        if (n === 3) return '3rd';
        return `${n}th`;
    };

    if (typeOfStudy === 'regular') {
        const classNo = index + 4; // 0 → 4th, 6 → 10th
        return `${suffix(classNo)} Class`;
    }

    if (typeOfStudy === 'private') {
        const mapping = {
            0: 6,
            1: 5,
            2: 4,
            3: 3,
            4: 2,
            5: 1,
            6: 0, // SSC appearing
        };

        const year = mapping[index];

        if (year === 0) {
            return `Place of First Appearing for SSC`;
        }

        return `${suffix(year)} Preceding Year`;
    }

    return '';
}

export default function EducationDetails(props) {
    const { Formik, sevenData } = props;

    const [showDistricts, setDistricts] = useState([
        ...(data?.districts || []), {
            "dist_code": 999,
            "dist_name": "Other State",
        }// Spread the districts array if it exists, otherwise use an empty array
    ]);

    const [list, setList] = useState([]);
    useEffect(() => { 
        setList(sevenData) }, [sevenData])
    const handleSelectChange = (e, index) => {
        const selectedValue = e.target.value;
        setList((prevList) => {
            const newList = [...prevList];
            newList[index] = selectedValue;
            return newList;
        });
    };
    const findHighestRepeatedValue = (arr) => {
        const countMap = {};
        const lastIndexMap = {};
        arr.forEach((value, index) => {
            countMap[value] = (countMap[value] || 0) + 1;
            lastIndexMap[value] = index;
        });

        let maxCount = 0;
        let maxValue = null;

        for (const [value, count] of Object.entries(countMap)) {
            if (count > maxCount || (count === maxCount && lastIndexMap[value] > lastIndexMap[maxValue])) {
                maxCount = count;
                maxValue = value;
            }
        }
        return maxValue !== null ? parseInt(maxValue) : null;
    };
    const [localDist, setLocalDist] = useState([{ dist_code: '0', dist_name: 'Not Yet Loaded' }])

    useEffect(() => {

        if (list?.length === 7) {
            let filteredData = showDistricts?.filter((val) => val.dist_code === findHighestRepeatedValue(list));
            if (filteredData?.length > 0) {
                if (filteredData[0]?.dist_code === '999' || filteredData[0]?.dist_code === 999) {
                    setLocalDist([{ dist_code: '999', dist_name: 'NON-LOCAL TO ALL Areas' }]);
                    Formik.setFieldValue('localDistCode', '999');
                }
                else {
                    setLocalDist(filteredData);
                    Formik.setFieldValue('localDistCode', filteredData[0]?.dist_code);
                }
            }
            else {
                Formik.setFieldValue('localDistCode', '0');
            }
        }
    }, [list]);

// useEffect(() => {
//     if (parseInt(Formik?.values?.localDistCode) === 999) {
//         Swal.fire({
//             icon: "warning",
//             title: "Warning",
//             text: "Non Local Candidates not eligible for this post..!"
//         }).then(() => {
//             onClear('district1');
//             onClear('district2');
//             onClear('district3');
//             onClear('district4');
//             onClear('district5');
//             onClear('district6');
//             onClear('district7');
//             setList([])
//             setLocalDist([{ dist_code: '0', dist_name: 'Not Yet Loaded' }])
//         });
//     }
// }, [Formik?.values?.localDistCode]);

    function onClear(name) {
        Formik.setFieldValue(name, '')
    }
    return (
        <React.Fragment>
            <div className="personal-head mt-2">
                <span>Basic Education Details</span>
            </div>
            <div className="personal-row personal-roweducation">
                <Row>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12}>
                        <Row>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                <Form.Group controlId="typeOfStudy">
                                    <Form.Label className="input-lable study-label-text">
                                        <p className="mb-0">Type of Study(School Education)<font color="red">*</font></p>
                                        <p className="mb-0">(Please select the district / Study / Residence respectively)</p></Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                <div className="form-border form-control">
                                    <Field
                                        type="radio"
                                        name="typeOfStudy"
                                        value="regular"
                                        className="form-sub"
                                        onChange={() => {
                                            onClear('district1');
                                            onClear('district2');
                                            onClear('district3');
                                            onClear('district4');
                                            onClear('district5');
                                            onClear('district6');
                                            onClear('district7');
                                            onClear('district7');
                                            onClear('localDistCode');
                                            setList([])
                                            setLocalDist([{ dist_code: '0', dist_name: 'Not Yet Loaded' }])
                                        }}
                                    />&nbsp;
                                    Regular &nbsp;
                                    <Field
                                        type="radio"
                                        name="typeOfStudy"
                                        value="private"
                                        className="form-sub"
                                        onChange={() => {
                                            onClear('district1');
                                            onClear('district2');
                                            onClear('district3');
                                            onClear('district4');
                                            onClear('district5');
                                            onClear('district6');
                                            onClear('district7');
                                            onClear('localDistCode');
                                            setList([])
                                            setLocalDist([{ dist_code: '0', dist_name: 'Not Yet Loaded' }])
                                        }}
                                    /> &nbsp;
                                    Private
                                </div>
                                <ErrorMessage
                                    name="typeOfStudy"
                                    component="div"
                                    className="text-error"
                                />
                            </Col>
                            {(Formik?.values?.typeOfStudy === 'regular' || Formik?.values?.typeOfStudy === 'private') &&
                                (
                                    <React.Fragment>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            {Formik.values.typeOfStudy === 'regular' ? <Form.Group>
                                                <Form.Label className="input-lable"> 4 <sup> Th </sup>
                                                    Class<font color="red">*</font></Form.Label>
                                            </Form.Group> : Formik.values.typeOfStudy === 'private' ? <Form.Group>
                                                <Form.Label className="input-lable">6 <sup> Th </sup>
                                                    Preceding Year<font color="red">*</font> </Form.Label>
                                            </Form.Group> : ''}
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            <div className="input-div position-relative">
                                                <Form.Group controlId="district1">

                                                    <Field as="select" className="input-field form-control mb-1"
                                                        onChange={(e) => {
                                                            handleSelectChange(e, 0);

                                                        }} name="district1">
                                                        <option value=""> -- Select District --</option>
                                                        {showDistricts.map((ds, i) => {
                                                            return (<option key={i} value={ds.dist_code}>{ds.dist_name}</option>);
                                                        })}
                                                    </Field>
                                                    <ErrorMessage
                                                        name="district1"
                                                        component="div"
                                                        className="text-error"
                                                    />
                                                </Form.Group>
                                                <IoIosArrowDown className="dropdown-icon" />
                                            </div>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            {Formik.values.typeOfStudy === 'regular' ? <Form.Group>
                                                <Form.Label className="input-lable"> 5 <sup> Th </sup>
                                                    Class<font color="red">*</font></Form.Label>
                                            </Form.Group> : Formik.values.typeOfStudy === 'private' ? <Form.Group>
                                                <Form.Label className="input-lable">5 <sup> Th </sup>
                                                    Preceding Year<font color="red">*</font> </Form.Label>
                                            </Form.Group> : ''}
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            <div className="input-div position-relative">
                                                <Form.Group controlId="district2">

                                                    <Field as="select" className="input-field form-control mb-1"
                                                        onChange={(e) => {
                                                            handleSelectChange(e, 1);

                                                        }}
                                                        name="district2">
                                                        <option value="">-- Select District --</option>
                                                        {showDistricts.map((ds, i) => {
                                                            return (<option key={i} value={ds.dist_code}>{ds.dist_name}</option>);
                                                        })}
                                                    </Field>
                                                    <ErrorMessage
                                                        name="district2"
                                                        component="div"
                                                        className="text-error"
                                                    />
                                                </Form.Group>
                                                <IoIosArrowDown className="dropdown-icon" />
                                            </div>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            {Formik.values.typeOfStudy === 'regular' ? <Form.Group>
                                                <Form.Label className="input-lable"> 6 <sup> Th </sup>
                                                    Class<font color="red">*</font></Form.Label>
                                            </Form.Group> : Formik.values.typeOfStudy === 'private' ? <Form.Group>
                                                <Form.Label className="input-lable">4 <sup> Th </sup>
                                                    Preceding Year<font color="red">*</font> </Form.Label>
                                            </Form.Group> : ''}
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            <div className="input-div position-relative">
                                                <Form.Group controlId="district3">

                                                    <Field as="select" className="input-field form-control mb-1"
                                                        name="district3" onChange={(e) => {
                                                            handleSelectChange(e, 2);

                                                        }}>
                                                        <option value="">-- Select District --</option>
                                                        {showDistricts.map((ds, i) => {
                                                            return (<option key={i} value={ds.dist_code}>{ds.dist_name}</option>);
                                                        })}
                                                    </Field>
                                                    <ErrorMessage
                                                        name="district3"
                                                        component="div"
                                                        className="text-error"
                                                    />
                                                </Form.Group>
                                                <IoIosArrowDown className="dropdown-icon" />
                                            </div>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            {Formik.values.typeOfStudy === 'regular' ? <Form.Group>
                                                <Form.Label className="input-lable"> 7 <sup> Th </sup>
                                                    Class<font color="red">*</font></Form.Label>
                                            </Form.Group> : Formik.values.typeOfStudy === 'private' ? <Form.Group>
                                                <Form.Label className="input-lable">3 <sup> rd </sup>
                                                    Preceding Year<font color="red">*</font> </Form.Label>
                                            </Form.Group> : ''}
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            <div className="input-div position-relative">
                                                <Form.Group controlId="district4">

                                                    <Field as="select" className="input-field form-control mb-1"
                                                        onChange={(e) => {
                                                            handleSelectChange(e, 3);
                                                        }} name="district4">
                                                        <option value="">-- Select District --</option>
                                                        {showDistricts.map((ds, i) => {
                                                            return (<option key={i} value={ds.dist_code}>{ds.dist_name}</option>);
                                                        })}
                                                    </Field>
                                                    <ErrorMessage
                                                        name="district4"
                                                        component="div"
                                                        className="text-error"
                                                    />
                                                </Form.Group>
                                                <IoIosArrowDown className="dropdown-icon" />
                                            </div>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            {Formik.values.typeOfStudy === 'regular' ?
                                                <Form.Group><Form.Label className="input-lable"> 8 <sup> Th </sup>
                                                    Class<font color="red">*</font></Form.Label></Form.Group>
                                                : Formik.values.typeOfStudy === 'private' ?
                                                    <Form.Group><Form.Label className="input-lable">2 <sup> nd </sup>
                                                        Preceding Year<font color="red">*</font> </Form.Label></Form.Group>
                                                    : ''}
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            <div className="input-div position-relative">
                                                <Form.Group controlId="district5">
                                                    <Field as="select" className="input-field form-control mb-1"
                                                        onChange={(e) => {
                                                            handleSelectChange(e, 4);
                                                        }} name="district5">
                                                        <option value="">-- Select District --</option>
                                                        {showDistricts.map((ds, i) => {
                                                            return (<option key={i} value={ds.dist_code}>{ds.dist_name}</option>);
                                                        })}
                                                    </Field>
                                                    <ErrorMessage
                                                        name="district5"
                                                        component="div"
                                                        className="text-error"
                                                    />
                                                </Form.Group>
                                                <IoIosArrowDown className="dropdown-icon" />
                                            </div>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            {Formik.values.typeOfStudy === 'regular' ? <Form.Group>
                                                <Form.Label className="input-lable"> 9 <sup> Th </sup>
                                                    Class<font color="red">*</font></Form.Label>
                                            </Form.Group> : Formik.values.typeOfStudy === 'private' ? <Form.Group>
                                                <Form.Label className="input-lable">1 <sup> st </sup>
                                                    Preceding Year<font color="red">*</font> </Form.Label>
                                            </Form.Group> : ''}
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            <div className="input-div position-relative">
                                                <Form.Group controlId="district6">
                                                    <Field as="select" className="input-field form-control mb-1"
                                                        onChange={(e) => {
                                                            handleSelectChange(e, 5);

                                                        }} name="district6">
                                                        <option value="">-- Select District --</option>
                                                        {showDistricts.map((ds, i) => {
                                                            return (<option key={i} value={ds.dist_code}>{ds.dist_name}</option>);
                                                        })}
                                                    </Field>
                                                    <ErrorMessage
                                                        name="district6"
                                                        component="div"
                                                        className="text-error"
                                                    />
                                                </Form.Group>
                                                <IoIosArrowDown className="dropdown-icon" />
                                            </div>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            {Formik.values.typeOfStudy === 'regular' ? <Form.Group>
                                                <Form.Label className="input-lable"> 10 <sup> Th </sup>
                                                    Class<font color="red">*</font></Form.Label>
                                            </Form.Group> : Formik.values.typeOfStudy === 'private' ? <Form.Group>
                                                <Form.Label className="input-lable">
                                                    Place of First Appearing for SSC<font color="red">*</font> </Form.Label>
                                            </Form.Group> : ''}
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            <div className="input-div position-relative">
                                                <Form.Group controlId="district7">
                                                    <Field as="select" className="input-field form-control mb-1"
                                                        onChange={(e) => {
                                                            handleSelectChange(e, 6);

                                                        }} name="district7">
                                                        <option value="">-- Select District --</option>
                                                        {showDistricts.map((ds, i) => {
                                                            return (<option key={i} value={ds.dist_code}>{ds.dist_name}</option>);
                                                        })}
                                                    </Field>
                                                    <ErrorMessage
                                                        name="district7"
                                                        component="div"
                                                        className="text-error"
                                                    />
                                                </Form.Group>
                                                <IoIosArrowDown className="dropdown-icon" />
                                            </div>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            <Form.Group>
                                                <Form.Label className="input-lable"> Local District Area you Belong:<font color="red">*</font></Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="mb-2">
                                            <div className="input-div position-relative">
                                                <Form.Group controlId="localDistCode">
                                                    <Field as="select" className="input-field form-control mb-1" name="localDistCode" >
                                                        {/* <option value='0'>Select</option> */}
                                                        <React.Fragment>
                                                            {localDist?.map((ds, i) => (
                                                                <option key={i} value={ds.dist_code}>
                                                                    {ds.dist_name}
                                                                </option>
                                                            ))}
                                                        </React.Fragment>
                                                    </Field>
                                                    <ErrorMessage
                                                        name="localDistCode"
                                                        component="div"
                                                        className="text-error"
                                                    />
                                                </Form.Group>
                                                <IoIosArrowDown className="dropdown-icon" />
                                            </div>
                                        </Col>
                                    </React.Fragment>
                                )
                            }
                        </Row>
                    </Col>

                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12} className="mt-4 mt-xl-0">
                        <Row><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="mb-2">
                            <div className="alert alert-warning">
                                <strong>Regular:</strong> Candidates who have continuous 7
                                years of study in school and resided in AP

                            </div>
                            <div className="alert alert-warning">
                                <strong>Private :</strong> Candidates who have not studied in
                                any educational institution during the whole or part of
                                preceding 7 years of study in which he/she appeared for the
                                SSC examination.
                               
                            </div></Col>
                            
                            {(parseInt(Formik?.values?.localDistCode) === 999) && <>
                                <Col xxl={8} xl={8} lg={12} md={12} sm={12} xs={12} className="mb-2">
    <Form.Group controlId="~" >
        <Form.Label className="input-lable mb-2">
            Are You migrated from Telangana after bifurcation of State i.e on 02/06/2014 and are you claiming under the G.O MS No 133
            <font color="red">*</font>
        </Form.Label>

        <div className="form-border form-control">
            <Field
                type="radio"
                name="isTelangana"
                value="true"
                className="form-sub me-1"
                onClick={() => {
                    Formik.setFieldValue('isTelangana', 'true');
                    Formik.setFieldValue('claimingDistrict', '');
                }}
            />
            Yes &nbsp;&nbsp;&nbsp;&nbsp;
             <Field
                type="radio"
                name="isTelangana"
                value="false"
                className="form-sub me-1"
                onClick={() => {
                    Formik.setFieldValue('isTelangana', 'false');
                    Formik.setFieldValue('claimingDistrict', '');

                    Swal.fire({
                        icon: "warning",
                        title: "Warning",
                        text: "Non Local Candidates are not eligible for this recruitment..!"
                    }).then(() => {
                        Formik.setFieldValue('isTelangana', '');
                    });
                }}
            />
            No
        </div>

        <ErrorMessage
            name="isTelangana"
            component="div"
            className="text-error"
        />
    </Form.Group>
</Col>    {Formik?.values?.isTelangana === "true" ?
                                    <Col xxl={4} xl={4} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                        <div className="input-div position-relative">
                                            <Form.Group controlId="claimingDistrict" >
                                                <Form.Label className="input-lable mb-3">Claiming Local District<font color="red">*</font>
                                                </Form.Label>
                                                <Field as="select" className="input-field form-control" name="claimingDistrict"
                                                >
                                                    <option>Select</option>
                                                    {showDistricts?.filter(ds => ds.dist_code !== 999)?.map((ds, i) => {
                                                        return (<option key={i} value={ds.dist_code}>{ds.dist_name}</option>);
                                                    })}
                                                </Field>
                                                <IoIosArrowDown className="dropdown-icon newdropdown" />
                                                <ErrorMessage
                                                    name="claimingDistrict"
                                                    component="div"
                                                    className="text-error"
                                                />
                                            </Form.Group>
                                            </div>
                                    </Col> : ""
                                }</>
                            }
                        </Row>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}
